import { Card, CardContent } from '@/components/ui/Card.js';
import { Button } from '@/components/ui/Button.js';
import { KeyRound, Plus } from 'lucide-react';

export function ApiKeysPage(): JSX.Element {
  return (
    <div className="space-y-6">
      <header className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">API keys</h1>
          <p className="text-sm text-muted-foreground">
            Service-account keys for machine-to-machine access. Cannot perform user-only actions.
          </p>
        </div>
        <Button>
          <Plus className="h-4 w-4" />
          Issue key
        </Button>
      </header>
      <Card>
        <CardContent className="py-12 text-center text-sm text-muted-foreground">
          <KeyRound className="mx-auto mb-3 h-8 w-8 opacity-50" />
          <p>No API keys yet.</p>
          <p className="mt-1 text-xs">Issue one to grant a service account programmatic access.</p>
        </CardContent>
      </Card>
    </div>
  );
}
